import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVultrComponent } from './simple-icons-vultr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVultrComponent ],
    exports:      [ SimpleIconsVultrComponent ],
    bootstrap:    []
})
export class SimpleIconsVultrModule {}
